import KanbanSkeleton from './KanbanSkeleton'

export default KanbanSkeleton
